export default function PDPAModalTHView (props) {
	return (
    <iframe title="pdpa_th" src="/pdpa_th.pdf" width="100%" height="700" />
  )
}
